import React, { useContext } from 'react'
import { Outlet, Navigate, useLocation } from 'react-router-dom'
import { AppContext } from '../App.context'

export default function PrivateRoute({ children }) {
  const { appState } = useContext(AppContext)
  const location = useLocation()

  const content = children ?? <Outlet />

  return appState.accessToken
    ? content
    : <Navigate to="/login" replace state={{ from: location }} />
}
